(function () {
  var ZOOM_SIZE = '220%';
  var MOBILE_QUERY = '(max-width: 749px)';

  function isMobile() {
    return window.matchMedia(MOBILE_QUERY).matches;
  }

  function TapZoom(wrapper) {
    this.wrapper = wrapper;
    this.zoomUrl = wrapper.dataset.zoom;
    if (!this.zoomUrl) return;

    this.overlay = null;
    this.zoomed = false;

    this._onTap = this._onTap.bind(this);
    wrapper.addEventListener('click', this._onTap, true);
  }

  TapZoom.prototype._ensureOverlay = function () {
    if (this.overlay) return this.overlay;
    var overlay = document.createElement('div');
    overlay.className = 'ar-tap-zoom-overlay';
    overlay.setAttribute('aria-hidden', 'true');
    overlay.style.backgroundImage = 'url(' + this.zoomUrl + ')';
    this.wrapper.appendChild(overlay);
    this.overlay = overlay;
    return overlay;
  };

  TapZoom.prototype._onTap = function (e) {
    if (!isMobile()) return;

    if (this.zoomed) {
      this._zoomOut();
      e.preventDefault();
      e.stopPropagation();
      return;
    }

    var rect = this.wrapper.getBoundingClientRect();
    if (!rect.width || !rect.height) return;

    var x = e.clientX - rect.left;
    var y = e.clientY - rect.top;
    var px = Math.max(0, Math.min(100, (x / rect.width) * 100));
    var py = Math.max(0, Math.min(100, (y / rect.height) * 100));

    this._zoomIn(px, py);
    e.preventDefault();
    e.stopPropagation();
  };

  TapZoom.prototype._zoomIn = function (px, py) {
    var overlay = this._ensureOverlay();
    overlay.style.backgroundPosition = px + '% ' + py + '%';
    overlay.style.backgroundSize = ZOOM_SIZE;
    overlay.style.display = 'block';
    this.zoomed = true;
  };

  TapZoom.prototype._zoomOut = function () {
    if (this.overlay) this.overlay.style.display = 'none';
    this.zoomed = false;
  };

  function init() {
    if (!isMobile()) return;
    var wrappers = document.querySelectorAll('[data-image-zoom-wrapper]');
    wrappers.forEach(function (wrapper) {
      if (wrapper.dataset.arTapZoomInit) return;
      wrapper.dataset.arTapZoomInit = '1';
      new TapZoom(wrapper);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', init);
  document.addEventListener('shopify:section:load', function () {
    setTimeout(init, 50);
  });
})();
